import { render } from "./ChatLayout.vue?vue&type=template&id=9c64175e&scoped=true"
import script from "./ChatLayout.vue?vue&type=script&lang=js"
export * from "./ChatLayout.vue?vue&type=script&lang=js"

import "./ChatLayout.vue?vue&type=style&index=0&id=9c64175e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c64175e"]])

export default __exports__